import { gql } from "@apollo/client"

export const GET_PERSON_ID_VERIFICATIONS = gql`
  query getPersonIdVerifications($id: String!) {
    node(id: $id) {
      id
      __typename
      ... on Person {
        id
        identityVerifications {
          items {
            id
            authority
            externalId
            backOfficeId
            rejectedAt
            rejectionCause
            createdAt
            sentAt
          }
        }
      }
    }
  }
`
